import axios from 'axios'

export default class ShopApiClient {
  constructor({ config }) {
    this.baseUrl = config.baseUrl
  }
  
  async getCable ({ id }) {
    // console.info('test')
    try {
      let response = await axios.get(`/api/v1/article/cable/${id}`)
      return { 
        success: response.data.success, 
        message: response.data.message, 
        id: id, 
        config: response.data.config,
        vnext_data: response.data.vnext_data
     }
    } catch (error) {
      return { error }
    }
  }

  async postCable ({ data }) {
    try {
      let response = await axios.post(`/api/v1/article/cable`, data)
      return { success: response.data.success, message: response.data.message, id: response.data.id }
    } catch (error) {
      return { error }
    }
  }

  async updateCable ({ id, data }) {
    try {
      let response = await axios.put(`/api/v1/article/cable/${id}`, data)
      return { success: response.data.success, message: response.data.message, id: response.data.id }
    } catch (error) {
      return { error }
    }
  }

  async getCart () {
    try {
      let response = await axios.get(`/api/v1/cart`)
      return response.data
    } catch (error) {
      return { error }
    }
  }

  async addToCart ({ id, type, quantity, length }) {
    try {
      let response = await axios.post(`/api/v1/cart`, {
        id,
        type,
        count: quantity,
        length
      })
      return { success: response.data.success, message: response.data.message, cart: response.data.cart }
    } catch (error) {
      return { error }
    }
  }

  async addToFavorites ({ id }) {
    try {
      let response = await axios.post(`/api/v1/favorites/${id}`)
      return { success: response.data.success, message: response.data.message, id: response.data.id , favoritesCount: response.data.favorites_count }
    } catch (error) {
      return { error }
    }
  }

  async getCurrentUserInfo () {
    try {
      let response = await axios.get(`/api/v1/user`)
      return { success: response.data.success, message: response.data.message, userData: response.data.user }
    } catch (error) {
      return { 
        success: false,
        error,
        userData: {}
      }
    }
  }

  async getBestsellerData (id) {
    let { data: { data: bestsellerData }} = await axios.get(process.env.VUE_APP_BESTSELLER_URL)
    // eslint-disable-next-line
    let vnextData = bestsellerData.translations[0].bestseller.find(b => b.id === id).vnext_data
    return vnextData
  }

  async getProjects () {
    try {
      let response = await axios.get(`/api/v1/project`)
      return { success: response.data.success, message: response.data.message, projects: response.data.projects }
    } catch (error) {
      return { 
        success: false,
        error,
        projects: []
      }
    }
  }

  async addProjectsAsCustomer (projectName) {
    try {
      let response = await axios.post(`/api/v1/project`, { name: projectName, parent_id: null })
      return { success: response.data.success, id: response.data.id }
    } catch (error) {
      return { success: false, error }
    }
  }

  async refreshCustomerFilters () {
    try {
      let response = await axios.get('/login/userfilter')
      return { success: response.data.success }
    } catch(error){
      return { success: false, error }
    }
  }

    /**
   * Create a new component article
   * @param {Object} data - Component payload
   * Example:
   * {
   *   artnr: "12345",
   *   name: "Component",
   *   description: "Custom component",
   *   price: 12.45,
   *   productgroup: 4,
   *   length: 10,
   *   show_in_catalog: false
   * }
   */
  async postComponent({ data }) {
    try {
      let response = await axios.post(`/api/v1/article/component`, data)
      return { 
        success: response.data.success !== false, 
        message: response.data.message || 'Component created successfully', 
        id: response.data.id 
      }
    } catch (error) {
      return { success: false, error }
    }
  }

  /**
   * Update an existing component by ID
   * @param {Number|String} id - Component ID
   * @param {Object} data - Updated component fields
   */
  async updateComponent({ id, data }) {
    try {
      let response = await axios.put(`/api/v1/article/component/${id}`, data)
      return { 
        success: response.data.success !== false, 
        message: response.data.message || 'Component updated successfully', 
        id: response.data.id 
      }
    } catch (error) {
      return { success: false, error }
    }
  }

}

export const ShopApiClientVuePlugin = {
  install (Vue, config) {
    Object.defineProperty(Vue.prototype, '$shopApiClient', {
      get: () => new ShopApiClient(config ? config : {
        config: {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      })
    })
  }
}
